import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";
import { loadUserTz, useUserTz } from "@/lib/tz";
import { toast } from "sonner";

export function TimezoneSetting() {
  const cur = useUserTz();
  const [opts, setOpts] = useState(null);
  const [val, setVal] = useState("");
  useEffect(() => { api.get("/timezones").then((r) => setOpts(r.data)).catch(() => setOpts({ common: [], all: [] })); }, []);
  useEffect(() => { setVal(cur.source === "user" ? cur.timezone : ""); }, [cur.timezone, cur.source]);
  const save = async () => {
    try { await api.put("/me/timezone", { timezone: val || null }); await loadUserTz(); toast.success("Time zone saved"); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div id="timezone" className="rounded-xl border border-slate-200 bg-white p-4 scroll-mt-20" data-testid="tz-setting">
      <p className="font-semibold text-slate-900 flex items-center gap-2"><Globe className="w-4 h-4 text-[#006090]" />Time Zone</p>
      <p className="text-xs text-slate-500 mt-1">Your calendar, appointments and training times show in this time zone. Leave it on the group default to follow your group{cur.group_default ? ` (${cur.group_default})` : ""}.</p>
      <div className="mt-3 flex flex-wrap gap-2 items-center">
        <select value={val} onChange={(e) => setVal(e.target.value)} disabled={cur.read_only} className="h-9 rounded-md border border-slate-300 px-2 text-sm min-w-[260px]" data-testid="tz-select">
          <option value="">Use group default{cur.group_default ? ` — ${cur.group_default}` : ""}</option>
          {opts && <optgroup label="United States">{opts.common.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</optgroup>}
          {opts && <optgroup label="All time zones">{opts.all.map((t) => <option key={t} value={t}>{t}</option>)}</optgroup>}
        </select>
        <Button size="sm" onClick={save} disabled={cur.read_only} className="bg-brand hover:bg-brand-strong" data-testid="tz-save">Save</Button>
        <span className="text-xs text-slate-600" data-testid="tz-current">Now showing: <b>{cur.label || cur.timezone}</b></span>
      </div>
      {cur.read_only && <p className="text-xs text-slate-500 mt-1">View As is read-only.</p>}
    </div>
  );
}
